import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=15ba260b&"
import script from "./Cart.vue?vue&type=script&lang=js&"
export * from "./Cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,FreeShippingNotification: require('/~/src/components/FreeShippingNotification.vue').default,CartItem: require('/~/src/modules/opus-ecom/components/Cart/CartItem.vue').default,CartTotals: require('/~/src/components/CartTotals.vue').default,OpusButton: require('/~/src/modules/opus/components/Form/Button.vue').default})
